import { render, staticRenderFns } from "./ArticleImage.vue?vue&type=template&id=07c8620f&scoped=true&"
import script from "./ArticleImage.vue?vue&type=script&lang=js&"
export * from "./ArticleImage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleImage.vue?vue&type=style&index=0&id=07c8620f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c8620f",
  null
  
)

export default component.exports